export default "__VITE_ASSET__M4H9mTub__"